import React from 'react';
import PropTypes from 'prop-types';
import { FlexGrid } from '@gasbuddy/react-components';
import styles from './styles.css';
import { ReviewRatingType } from '../../../utils/prop-types/rating-types';
import ImageWithText from '../../image-with-text';

const renderCategoryRatingColumn = rating => (
  <FlexGrid.Column desktop={3} mobile={12} tablet={4} key={rating.category_id}>
    <ImageWithText
      className={styles.verticalLine}
      text={rating.category}
      imageName={rating.category}
      imageWidth={36}
      imageHeight={36}
      imageSource={`/images/stationProfile/v2/rating/rating-${rating.value.toLowerCase()}.svg`}
    />
  </FlexGrid.Column>
);

const ReviewRatings = ({ overallRating, categoryRatings, insideModal }) => {
  const otherRatings = categoryRatings.filter(c => c.category.toLowerCase() !== 'overall' && c.value.toLowerCase() !== 'notapplicable');
  let overallRatingCss = `${styles.overallRatings} ${otherRatings.length ? styles.verticalSeparator : ''}`;
  overallRatingCss = `${overallRatingCss} ${insideModal ? styles.insideModal : ''}`;
  return (
    <FlexGrid container>

      <FlexGrid.Column desktop={3} mobile={12} tablet={12} className={overallRatingCss} key="overall">
        {(!!overallRating && overallRating.toLowerCase() !== 'notapplicable') && (
          <ImageWithText
            text="Overall Rating"
            imagePosition="Right"
            imageWidth={36}
            imageHeight={36}
            imageName="Overall"
            imageSource={`/images/stationProfile/v2/rating/rating-${overallRating.toLowerCase()}.svg`}
          />
        )}
      </FlexGrid.Column>

      {!!otherRatings.length
        && (
          <>
            <FlexGrid.Column desktop={2} mobile={12} tablet={12} className={styles.categoryRatingsLabel}>
              <div className={`${styles.boldText}`}>Category Ratings</div>
            </FlexGrid.Column>

            <FlexGrid.Column desktop={7} mobile={12} tablet={12} className={styles.categoryRatings}>
              <FlexGrid>
                {otherRatings.map(renderCategoryRatingColumn)}
              </FlexGrid>
            </FlexGrid.Column>
          </>
        )}

    </FlexGrid>
  );
};

ReviewRatings.propTypes = {
  overallRating: PropTypes.string.isRequired,
  categoryRatings: PropTypes.arrayOf(ReviewRatingType).isRequired,
  insideModal: PropTypes.bool,
};

ReviewRatings.defaultProps = {
  insideModal: false,
};

export default ReviewRatings;
